"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MaterialIcon = _interopRequireDefault(require("../MaterialIcon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _Hooks = require("../Hooks");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Input = _ref => {
  let {
    autocomplete,
    disabled = false,
    error = '',
    flex,
    fontSize = '14px',
    height = '40px',
    icon = null,
    margin,
    marginBottom = '15px',
    maxLength,
    onBlur = () => null,
    onChange = () => null,
    onEnterPress,
    padding = '10px',
    placeholder = '',
    textAlign = 'left',
    type = 'text',
    value = '',
    width = '100%'
  } = _ref;
  const {
    dangerColor,
    primaryColor
  } = (0, _styledComponents.useTheme)();
  const [showPassword, toggleShowPassword] = (0, _Hooks.useToggle)(false);
  const handleChange = value => {
    if (!!maxLength && value.length > maxLength) return;
    onChange(value);
  };
  const handleEnterPress = e => {
    if (!!onEnterPress) {
      const {
        key
      } = e;
      if (key !== 'Enter') {
        return;
      }
      e.preventDefault();
      onEnterPress();
    }
  };
  const handleViewPassword = e => {
    e.preventDefault();
    toggleShowPassword();
  };
  const isPassword = type === 'password';
  const parsedHeight = typeof height === 'string' ? height : "".concat(height.toString(), "px");
  const commonProps = {
    marginBottom
  };
  const containerProps = {
    flex
  };
  const iconProps = {
    error,
    height: parsedHeight
  };
  const inputProps = {
    autocomplete,
    disabled,
    error,
    fontSize,
    height: parsedHeight,
    isPassword,
    margin,
    marginBottom,
    onBlur: _ref2 => {
      let {
        currentTarget: {
          value
        }
      } = _ref2;
      return onBlur(value);
    },
    onChange: _ref3 => {
      let {
        currentTarget: {
          value
        }
      } = _ref3;
      return handleChange(value);
    },
    onKeyPress: handleEnterPress,
    padding,
    placeholder,
    textAlign,
    value,
    width
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [!['area'].includes(type) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.InputStyled, _objectSpread(_objectSpread(_objectSpread({}, commonProps), inputProps), {}, {
      type: isPassword && showPassword ? 'text' : type
    })), type === 'area' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.AreaStyled, _objectSpread(_objectSpread({}, commonProps), inputProps)), isPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.ViewButton, _objectSpread(_objectSpread({}, iconProps), {}, {
      onClick: handleViewPassword,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
        color: !!error ? dangerColor : primaryColor,
        icon: showPassword ? 'visibility_off' : 'visibility'
      })
    })), icon && !isPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.ViewButton, _objectSpread(_objectSpread({}, iconProps), {}, {
      onClick: onEnterPress,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
        color: !!error ? dangerColor : primaryColor,
        icon: icon
      })
    })), !!error && typeof error === 'string' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Error, _objectSpread(_objectSpread({}, commonProps), {}, {
      children: error
    }))]
  }));
};
Input.propTypes = {
  autocomplete: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  flex: _propTypes.default.string,
  fontSize: _propTypes.default.string,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  icon: _propTypes.default.string,
  lines: _propTypes.default.number,
  margin: _propTypes.default.string,
  marginBottom: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onEnterPress: _propTypes.default.func,
  padding: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  textAlign: _propTypes.default.string,
  type: _propTypes.default.string,
  value: _propTypes.default.string,
  width: _propTypes.default.string
};
var _default = exports.default = Input;